"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var window_wrapper_1 = require("./window_wrapper");
var qs = require("qs");
function isActive(to, current) {
    return (to.pathname === current.pathname &&
        to.hash === current.hash);
}
exports.isActive = isActive;
function serializeURL(url) {
    if (!url) {
        return;
    }
    var origin = url.origin, pathname = url.pathname, query = url.query, hash = url.hash;
    var search = '';
    if (query && Object.keys(query).length) {
        search = "?" + qs.stringify(query);
    }
    var href = "" + (origin || '') + (pathname || '') + search + (hash || '');
    if (href === '') {
        return;
    }
    return href;
}
exports.serializeURL = serializeURL;
function parseURL(to) {
    if (!to) {
        return {};
    }
    // Yes this is set to the string, null in production while in RRE.
    var origin;
    if (!window_wrapper_1.default.location.origin || window_wrapper_1.default.location.origin === 'null') {
        origin = WEB_HOST;
    }
    else {
        origin = window_wrapper_1.default.location.origin;
    }
    if (typeof to === 'string') {
        var u = void 0;
        // Allow relative and absolute URLs to be used, but respect a different domain
        if (to.match(/^http/)) {
            u = new URL(to);
        }
        else {
            u = new URL(to, origin);
        }
        return {
            origin: u.origin,
            pathname: u.pathname,
            query: qs.parse(u.search, { ignoreQueryPrefix: true }),
            hash: u.hash,
        };
    }
    var pathname = to.pathname;
    if (!pathname) {
        pathname = window_wrapper_1.default.location.pathname;
    }
    var hash;
    if (to.anchor) {
        hash = "#" + to.anchor;
    }
    return {
        origin: origin,
        pathname: pathname,
        hash: hash,
        query: to.query,
    };
}
exports.parseURL = parseURL;
//# sourceMappingURL=link_parser.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/link_parser.js
// module id = WflO
// module chunks = 20 21